"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = void 0;
const Popup_1 = __importDefault(require("./Popup"));
exports.Popup = Popup_1.default;
exports.default = Popup_1.default;
